
































const isElement = (x: any): x is HTMLInputElement =>
  x instanceof HTMLInputElement;

import { Component, Prop, Vue } from "vue-property-decorator";
import { Const } from "@/const";
import * as def from "@/definitions";

import { CookieHelper } from "@/helper/cookieHelper";
import { DateHelper } from "@/helper/dateHelper";

@Component({
  components: {
  }
})
export default class QuestionaireBackAlertModal extends Vue 
{
    private get title() { return "ユーザー登録の中止"; }
    private get message1() { return "ユーザー登録にはアンケート回答が必須です。"; }
    private get message2() { return "ユーザー登録を中止してよろしいですか？"; }

    //configcolor
    private get userConfigColors(){
        return this.$store.getters.userConfigColors;
    }

    private get buttonColorStyle(){
        return {
            "background-color" : this.userConfigColors.buttonColorCode
        }
    }
}
